import { Box, Typography } from '@mui/material';
import RequestTypeCard from './RequestTypeCard';
import { useState } from 'react';

import hosting from '../../../assets/hosting.svg';
import product from '../../../assets/product.svg';
import development from '../../../assets/development.svg';
import consulting from '../../../assets/consulting.svg';

export default function RequestTypeSelector({ next }) {
  const [selected, setSelected] = useState(null);

  function handleChange(value) {
    setSelected(value);
    window.setTimeout(() => next({ type: value }), 100);
  }

  return (
    <>
      <Box>
        <Typography sx={{ fontSize: '24px', fontWeight: 'bold' }}>
          Neue Anfrage
        </Typography>
        <Typography sx={{ fontSize: '14px' }}>
          Lassen Sie uns wissen, woran Sie Interesse haben!
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          boxSizing: 'border-box',
          gap: 2,
        }}
      >
        <RequestTypeCard
          selected={selected === 'development'}
          select={() => handleChange('development')}
          image={development}
          title="Individualentwicklung"
          description="Wir entwickeln Software für Ihre Bedürfnisse"
        />
        <RequestTypeCard
          selected={selected === 'product'}
          select={() => handleChange('product')}
          image={product}
          title="Produkt"
          description="Testen Sie eines unserer Softwareprodukte"
        />
        <RequestTypeCard
          selected={selected === 'webhosting'}
          select={() => handleChange('webhosting')}
          image={hosting}
          title="Webhosting"
          description="Von Einzelseite bis Reseller-Paket oder Cloudumgebung"
        />
        <RequestTypeCard
          selected={selected === 'consulting'}
          select={() => handleChange('consulting')}
          image={consulting}
          title="Konzeptentwicklung"
          description="Wir entwickeln Cybersecurity- und Digitalisierungsstrategien"
        />
      </Box>
    </>
  );
}
